// ------------------------------------
// REACT IMPORTS
// ------------------------------------
import React from 'react';
import ReactDOM from 'react-dom';

// ------------------------------------
// ASSET IMPORTS
// ------------------------------------
import './App.css';
import ios from './ios.png';
import android from './android.png';
import data from "./data.js"

// ------------------------------------
// ELEMENTS
// ------------------------------------
class TriggerButton extends React.Component {
  render() {
    return (
      <div className="trigger-button trigger-button-small tag-manager-popup-open" onClick={this.props.action}>
        {data.texts[this.props.language].triggerButton}
      </div>
    );
  }
}

class Funnel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // stage is 0 if its not muenich
      // this is because there are no cities to choose from munich..ther is just munich..
      // so we skip the first step
      stage: this.props.passBrand == "CityTourCard" ? 1 : 0,
      cityId: this.props.passBrand == "CityTourCard" ? 0 : null,
    }
  }

  decreaseStage(){
    var oldStage = this.state.stage
    this.setState({
      stage: oldStage - 1,
      cityId: oldStage > 2 ? null : this.state.cityId
    })
  }

  increaseStage(cityId = null){
    this.setState({
      stage: this.state.stage + 1,
      cityId: cityId != null ? cityId : this.state.cityId
    })
  }

  renderActions(){
    var content = []
    if (this.state.stage == 0) {
      for (var i = 0; i < data.shops[this.props.passBrand].length; i++) {
        let cityId = i
        let city = data.shops[this.props.passBrand][i][this.props.language]
        content.push(
          <p key={i} className="trigger-button expand" onClick={()=>{this.increaseStage(cityId)}}>{city}</p>
        )
      }
    }else if (this.state.stage == 1){
      content.push(
        <a key={"tb1"} className="trigger-button expand tag-manager-store-open" target="_blank" href={data.shops[this.props.passBrand][this.state.cityId].url}>{data.texts[this.props.language].ticketButtons.print}</a>
      )
      if (data.shops[this.props.passBrand][this.state.cityId].apps) {
        content.push(
          <p key={"tb2"} className="trigger-button expand" onClick={()=>{this.increaseStage()}}>{data.texts[this.props.language].ticketButtons.mobile}</p>
        )
      }else{
        content.push(
          <p key={"tb2"} className="trigger-button expand dissabled">{data.texts[this.props.language].ticketButtons.mobileComingSoon}</p>
        )
      }
    }else{

      for (var j = 0; j < data.shops[this.props.passBrand][this.state.cityId].apps.length; j++) {
        content.push(
          <div key={j} className="partner-app">
            <img src={data.shops[this.props.passBrand][this.state.cityId].apps[j].logo} className="partner-app-logo" />
            <p>{data.shops[this.props.passBrand][this.state.cityId].apps[j].name}</p>
            <a target="_blank" href={data.shops[this.props.passBrand][this.state.cityId].apps[j].android} class="tag-manager-app-open">
              <img src={android} className="download-mobile" />
            </a>
            <a target="_blank" href={data.shops[this.props.passBrand][this.state.cityId].apps[j].ios} class="tag-manager-app-open">
              <img src={ios} className="download-mobile" />
            </a>
          </div>
        )
      }

    }

    return content
  }

  render() {
    var backButton = null
    if (this.state.stage >= 1) {
      backButton = <span className="backFunnel funnelActionButton" onClick={this.decreaseStage.bind(this)}>〱{data.texts[this.props.language].backButton}</span>
    }
    return (
      <div className="funnel-bg">
        <div className="funnel">
          <span className="closeFunnel funnelActionButton" onClick={this.props.closeAction}>×</span>
          {backButton}
          <div className="funnel-logo-container">
            <div className="funnel-logo-container2">
              <img src={data.logos[this.props.passBrand]} className="funnel-logo" />
            </div>
          </div>
          <h2>{data.texts[this.props.language].headline[this.state.stage]}</h2>
          <p>{data.texts[this.props.language].text[this.state.stage]}</p>
          {this.renderActions()}
        </div>
      </div>
    );
  }
}

// Element that generates a button which triggers a popup 
class FunnelApp extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
      showFunnel: false
    }
  }

  toggleFunnel(){
    this.setState({showFunnel: !this.state.showFunnel})
  }

  render() {
    var funnel = null
    if (this.state.showFunnel) {
      funnel = <Funnel language={this.props.language} closeAction={this.toggleFunnel.bind(this)} passBrand={this.props.passBrand}/>
    }
    return (
      <div>
        {funnel}
        <TriggerButton action={this.toggleFunnel.bind(this)} language={this.props.language} />
      </div>
    );
  }
}

// Element that generates a partner overview
class PartnerListApp extends React.Component{
  render() {
    var appElements =[]
    var allApps = []
    // get all partner/apps from a given passBrand
    // this.props.passBrand
    if (this.props.passBrand) {
      for (var i = 0; i < data.shops[this.props.passBrand].length; i++) {
        if (data.shops[this.props.passBrand][i].apps) {
          for (var j = 0; j < data.shops[this.props.passBrand][i].apps.length; j++) {
            allApps.push(data.shops[this.props.passBrand][i].apps[j])
          }
        }
      }
    // get all partner/apps
    }else{
      for (var passBrandCity in data.shops) {
        for (var i = 0; i < data.shops[passBrandCity].length; i++) {
          if (data.shops[passBrandCity][i].apps) {
            for (var j = 0; j < data.shops[passBrandCity][i].apps.length; j++) {
              allApps.push(data.shops[passBrandCity][i].apps[j])
            }
          }
        }
      }
    }
    
    // unique apps
    allApps = [...new Set(allApps)]
    console.log(allApps)

    for (var r = 0; r < allApps.length; r++) {
      appElements.push(
        <a key={r} target="_blank" rel="nofollow" href={allApps[r].onelink} className="partner-app">
          <img src={allApps[r].logo} className="partner-app-logo" />
          <p>{allApps[r].name}</p>
        </a>
      )
    }
    return (
      <div className="partner-loop">
        {appElements}
      </div>
    );
  }
}

// Render alls html elebents with the "funnel-element" and "partner-element" class as a button with a popup
document.addEventListener("DOMContentLoaded", function(event) {
  var funnelElements = document.getElementsByClassName("funnel-element")
  for (var i = 0; i < funnelElements.length; i++) {
    // elements except language codes like de_DE or de
    // we are reducing de_DE to de
    let lang = funnelElements[i].getAttribute('data-language')
    if (lang.includes("_")) {
      lang = lang.split("_")[0]
    }
    console.log(lang)
    ReactDOM.render(<FunnelApp language={lang} passBrand={funnelElements[i].getAttribute('data-brand')}/>, funnelElements[i]);
  }
  var partnerElements = document.getElementsByClassName("partner-element")
  for (var i = 0; i < partnerElements.length; i++) {
    ReactDOM.render(<PartnerListApp passBrand={partnerElements[i].getAttribute('data-brand')}/>, partnerElements[i]);
  }
});